import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@srm/ui/types/ModalSize';
import { IRemoveLinkExecutorProps } from './IRemoveLinkExecutorProps';
import { readActionReasonOptions } from '@organisms/actions/ActionReason/actionReason';
import { RemoveLinkExecutorModal } from './RemoveLinkExecutorModal';

export class RemoveLinkExecutor extends DocBaseActionExecutor {
    private _modalProps?: IRemoveLinkExecutorProps;

    runInternal = (
        _objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        const parts = this?._objId?.split('/');
        if (parts === undefined || parts.length != 2)
            throw new Error(`Не удалось распарсить ид документа и родители линка {parts}`);
        const ownerDocId = parts[0];
        const linkedDocId = parts[1];

        this._modalProps = {
            actKey: action.key,
            ownerDocId: ownerDocId,
            linkedDocId: linkedDocId,
            title: action.options?.title ?? '',
            message: action.options?.message ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'l',
            completeHandler: completeHandler,
            ...readActionReasonOptions(action.options),
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <RemoveLinkExecutorModal {...this._modalProps} /> : <div />;
    };
}
